import { Component, inject } from '@angular/core';
import { LegalLayoutComponent } from '@app/legal/layout/layout.component';
import { ContactsService } from '@services/contacts.services';

@Component({
  selector: 'app-legal-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  imports: [LegalLayoutComponent],
})
export class LegalPrivacyPolicyComponent {
  private contactService = inject(ContactsService);
  email = this.contactService.email;
  phone = this.contactService.phone;

  protected jumpToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
